import { connect } from 'react-redux';

import { Dropdown } from 'bricks/Dropdown';
import { setCapacityAndFetchMaxPrice } from 'store/widgets/TradeInNewCalculator/capacity/actions';
import {
  selectTradeInCapacityIsDisabled,
  selectTradeInCapacityListForSelect,
  selectTradeInCapacitySelectedValue,
  selectTradeInCapacityTitle,
  selectTradeInModelIsError,
} from 'store/widgets/TradeInNewCalculator/capacity/selectors';

import {
  DispatchPropsSelect,
  StatePropsSelect,
} from './types';

const mapStateToProps = (state): StatePropsSelect => ({
  title: selectTradeInCapacityTitle(state),
  value: selectTradeInCapacitySelectedValue(state),
  options: selectTradeInCapacityListForSelect(state),
  disabled: selectTradeInCapacityIsDisabled(state),
  error: {
    isError: selectTradeInModelIsError(state),
    message: '',
  },
});

const mapDispatchToProps = (dispatch): DispatchPropsSelect => ({
  onChange: (capacity) => {
    dispatch(setCapacityAndFetchMaxPrice(capacity));
  },
});

export const CapacitySelect = connect(mapStateToProps, mapDispatchToProps)(Dropdown);
